import { render, staticRenderFns } from "./HeadPortrait.vue?vue&type=template&id=2bf88f9d&scoped=true&"
import script from "./HeadPortrait.vue?vue&type=script&lang=js&"
export * from "./HeadPortrait.vue?vue&type=script&lang=js&"
import style0 from "./HeadPortrait.vue?vue&type=style&index=0&id=2bf88f9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf88f9d",
  null
  
)

export default component.exports